import * as angular from "angular";
import {UrlRouterProvider} from "@uirouter/angularjs";

class Routing {
    constructor($urlRouterProvider: UrlRouterProvider, $urlMatcherFactoryProvider, $locationProvider: ng.ILocationProvider) {
        $locationProvider.html5Mode(false);
        $urlMatcherFactoryProvider.caseInsensitive(true);
        $urlMatcherFactoryProvider.strictMode(false);
        $urlRouterProvider.otherwise('/');
    }
}


export default angular.module('routing', [])
    .config(Routing)
    .name;
